import React, { Suspense, lazy } from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'
import { FallbackView } from '../../_template/partials'
// import { MenuTestPage } from '../pages/MenuTestPage'

export function PrivateRoutes() {
    const DashboardPage = lazy(() => import('../modules/dashboard/DashboardPage'))
    const ProfilePage = lazy(() => import('../modules/profile/ProfilePage'))
    const MerchantPage = lazy(() => import('../modules/merchant/MerchantPage'))
    const UserPage = lazy(() => import('../modules/user/UserPage'))
    const UserApiPage = lazy(() => import('../modules/userapi/UserApiPage'))
    const PaymentPage = lazy(() => import('../modules/payment/PaymentPage'))
    const ReportsPage = lazy(() => import('../modules/reports/ReportsPage'))
    const LinkPaymentPage = lazy(() => import('../modules/linkpayment/LinkPaymentPage'))

    return (
        <Suspense fallback={<FallbackView />}>
            <Switch>
                <Route path='/profile' component={ProfilePage} />
                <Route path='/merchant' component={MerchantPage} />
                <Route path='/user' component={UserPage} />
                <Route path='/userapi' component={UserApiPage} />
                <Route path='/dashboard' component={DashboardPage} />
                <Route path='/payment' component={PaymentPage} />
                <Route path='/linkpayment' component={LinkPaymentPage} />
                <Route path='/report' component={ReportsPage} />
                <Redirect from='/auth' to='/dashboard' />
                <Redirect exact from='/' to='/dashboard' />
                <Redirect to='error/404' />
            </Switch>
        </Suspense>
    )
}
